angular.module('zc.commonApi')

.factory 'ProjectDeletedItemDetector', ($resource, $q, BaseProjectCrudService) ->
  class ProjectDeletedItemDetector extends BaseProjectCrudService

  new ProjectDeletedItemDetector(
    $resource
    $q
    '/api/master/projects/:projectId/deleted_item_detectors/:id'
    'deleted_item_detector'
    'deleted_item_detectors'
  )



// WEBPACK FOOTER //
// ../app_shared/src/shared_modules/common_api/api/deleted_item_detectors.coffee